import { Condition } from "./condition";
import ConditionalWrapper from "./conditionalWrapper";

export { Condition, ConditionalWrapper };

export default Condition;
